import AttributeEditorTable, {
  AttributeConfiguration,
} from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/Panels/AttributeEditorTable';
import { AccountInfoAttribute, ModuleAccountInfo } from 'dashboard/modules/AccountInfo/model';

export interface AccountInfoPanelProps {
  module: ModuleAccountInfo;
  updateModule: (module: ModuleAccountInfo) => void;
}

const AccountInfoPanel = ({ module, updateModule }: AccountInfoPanelProps) => {
  const updateAttributes = (attributes: AccountInfoAttribute[]) => {
    updateModule({ ...module, attributes });
  };

  const attributes: AttributeConfiguration<AccountInfoAttribute>[] = [
    {
      label: 'Account Type',
      key: 'account-type',
      display: true,
    },
    {
      label: 'Account ID',
      key: 'account-id',
      display: true,
    },
    {
      label: 'Reference ID',
      key: 'reference-id',
      display: true,
    },
    {
      label: 'Created at',
      key: 'created-at',
      display: true,
    },
    {
      label: 'Updated at',
      key: 'updated-at',
      display: true,
    },
  ];

  return (
    <AttributeEditorTable<AccountInfoAttribute>
      allAttributes={attributes}
      moduleAttributes={module.attributes}
      updateAttributes={updateAttributes}
    />
  );
};

export default AccountInfoPanel;
